export default {
	active: false,
	waitingUrls: [] as string[],
	show(): void {
		this.active = true;
	},
	hide(): void {
		this.active = false;
	},
	startRequest(url: string): void {
	  this.show();
	  this.waitingUrls.push(url);
	},
	finishRequest(url: string): void {
		this.waitingUrls.splice(this.waitingUrls.findIndex(savedUrl => savedUrl === url), 1);
		// Not hide loader on chained requests
		setTimeout(() => {
			if (!this.waitingUrls.length)
				this.hide();
		});
	}
};
